import Swal from "sweetalert2";
import { getUserTimezone } from "./timezoneHelper";

export const showAccountBlockedModal = (data, callback) => {
  const isStake = (window?.siteConfig?.active_design === 'stake');
  const reason = (data && data.reason) ? data.reason : "Violation of platform rules";
  const blockedUntil = (data && (data.blockedUntil || data.blocked_until)) ? (data.blockedUntil || data.blocked_until) : null;

  let untilStr = null;
  if (blockedUntil) {
    const d = new Date(blockedUntil);
    untilStr = !isNaN(d.getTime()) ? d.toLocaleString('en-GB', {
      timeZone: getUserTimezone(),
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true
    }) : blockedUntil;
  }

  const isTemporary = !!untilStr;

  // Dynamic CSS injection for theme-specific popup
  const styleId = "account-block-modal-styles";
  const existingTag = document.getElementById(styleId);
  if (existingTag) existingTag.remove();

  const styleTag = document.createElement("style");
  styleTag.id = styleId;
  styleTag.innerHTML = `
    .swal2-popup.compact-block-popup {
      max-width: 350px !important;
      width: calc(100vw - 32px) !important;
      padding: 18px 18px 16px !important;
      border-radius: ${isStake ? '12px' : '14px'} !important;
      background: ${isStake ? '#1a2c38' : '#1e2024'} !important;
      border: 1px solid ${isStake ? '#2f4553' : 'rgba(255, 255, 255, 0.08)'} !important;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.75) !important;
      box-sizing: border-box !important;
    }
    .swal2-popup.compact-block-popup .swal2-title {
      padding: 0 !important;
      margin: 0 0 6px !important;
    }
    .swal2-popup.compact-block-popup .swal2-html-container {
      margin: 0 !important;
      padding: 0 !important;
    }
    .swal2-popup.compact-block-popup .swal2-actions {
      margin: 12px 0 0 !important;
      width: 100% !important;
      padding: 0 !important;
    }
    .swal2-popup.compact-block-popup .compact-block-btn {
      width: 100% !important;
      height: 38px !important;
      border-radius: 8px !important;
      font-size: 13.5px !important;
      font-weight: ${isStake ? '600' : '700'} !important;
      border: none !important;
      cursor: pointer !important;
      outline: none !important;
      transition: all 0.15s ease !important;
      background: ${isStake ? '#1475e1' : 'linear-gradient(180deg, #3bc117 0%, #209900 100%)'} !important;
      color: #ffffff !important;
      box-shadow: ${isStake ? '0 4px 14px rgba(20, 117, 225, 0.35)' : '0 4px 14px rgba(59, 193, 23, 0.35)'} !important;
    }
    .swal2-popup.compact-block-popup .compact-block-btn:hover {
      background: ${isStake ? '#1880f0' : 'linear-gradient(180deg, #44dc1b 0%, #27b300 100%)'} !important;
      transform: translateY(-1px);
    }
  `;
  document.head.appendChild(styleTag);

  const iconSvg = `
    <div style="width: 36px; height: 36px; margin: 0 auto 8px; border-radius: 50%; background: rgba(239, 68, 68, 0.12); display: flex; align-items: center; justify-content: center;">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
      </svg>
    </div>
  `;

  const reasonCard = `
    <div style="background: ${isStake ? '#0f212e' : '#17181b'}; border: 1px solid ${isStake ? '#2f4553' : '#2d3035'}; border-radius: 8px; padding: 9px 12px; margin-top: 10px; text-align: left;">
      <div style="color: ${isStake ? '#b1bad3' : '#8c929a'}; font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 2px;">
        Reason for Block:
      </div>
      <div style="color: #ffffff; font-size: 13px; font-weight: 500; word-break: break-word; line-height: 1.4;">
        ${reason}
      </div>
    </div>
  `;

  const durationCard = isTemporary ? `
    <div style="background: rgba(234, 179, 8, 0.08); border: 1px solid rgba(234, 179, 8, 0.25); border-radius: 8px; padding: 9px 12px; margin-top: 7px; text-align: left;">
      <div style="color: #facc15; font-weight: 700; font-size: 11.5px; margin-bottom: 2px; display: flex; align-items: center; gap: 4px;">
        <span>⏱️</span> <span>Temporary Block</span>
      </div>
      <div style="color: #e2e8f0; font-size: 12px; line-height: 1.4;">
        Until: <span style="color: ${isStake ? '#38bdf8' : '#3bc117'}; font-weight: 600;">${untilStr}</span>
      </div>
    </div>
  ` : `
    <div style="background: rgba(239, 68, 68, 0.08); border: 1px solid rgba(239, 68, 68, 0.25); border-radius: 8px; padding: 9px 12px; margin-top: 7px; text-align: left;">
      <div style="color: #f87171; font-weight: 700; font-size: 11.5px; margin-bottom: 2px; display: flex; align-items: center; gap: 4px;">
        <span>🚫</span> <span>Permanent Block (Lifetime)</span>
      </div>
      <div style="color: ${isStake ? '#b1bad3' : '#8c929a'}; font-size: 11.5px; line-height: 1.4;">
        Account has been permanently restricted.
      </div>
    </div>
  `;

  Swal.fire({
    title: `<span style="color: #ffffff; font-size: 16.5px; font-weight: 700; display: block;">Account Restricted</span>`,
    html: `
      <div style="font-family: inherit; color: ${isStake ? '#b1bad3' : '#8c929a'}; font-size: 12px; text-align: center;">
        ${iconSvg}
        <p style="margin: 0 0 4px; color: ${isStake ? '#b1bad3' : '#8c929a'}; line-height: 1.4;">Your account access has been restricted by administrator.</p>
        ${reasonCard}
        ${durationCard}
        <p style="margin: 9px 0 0; font-size: 11px; color: ${isStake ? '#64748b' : '#6b7280'};">Please contact support if you believe this is in error.</p>
      </div>
    `,
    showConfirmButton: true,
    confirmButtonText: 'Understood',
    customClass: {
      popup: 'compact-block-popup',
      confirmButton: 'compact-block-btn',
    },
    buttonsStyling: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then(() => {
    if (callback) callback();
  });
};
